module.exports = __webpack_public_path__ + "static/img/cjzh-companyQualification.51092ba4.png";